const messages = {
  product_title: 'Messenger Service',
  sign_in: 'Iniciar Sesion',
  signing_in: 'Por favor espera...',
  staff_login: 'Acceso de Personal',
  or_divider: 'O',
  email_placeholder: 'Usuario',
  password_placeholder: 'Contrasena',
  show_password: 'Mostrar contrasena',
  hide_password: 'Ocultar contrasena',
  logo_alt: 'Logo de Roommatik',
  errors: {
    invalid_credentials: 'Email o contrasena invalidos.',
    google_unavailable: 'El inicio de sesion con Google no esta disponible en este momento.',
    google_missing_email: 'La cuenta de Google no proporciono un email.',
    generic: 'El inicio de sesion ha fallado. Intentalo de nuevo.',
  },
};

export default messages;
